
export enum ERoute {
  HOME = "home",
  KIDS_CLASS = "kidsClass",
  WHEEL_THROWING = "wheelThrowing",
  FAMILY_SATURDAY = "familySaturday",
  OPEN_STUDIO = "openStudio",
  FIRING_SERVICE = "firingService",
  GIFT_CERTIFICATE = "giftCertificate",
  TEAM_EVENTS = "teamEvents",
  BIRTHDAY_PARTIES ="birthdayParties",
  MEMBERSHIP = "membership",
  ABOUT = "about",
  RENT_A_SPACE = "rentASpace",
  CONTACT = "contact",
  IMPRESSUM = "impressum",
  AGB = "agb",
  DATENSCHUTZ = "datenschutz",
  NOT_FOUND = "notFound",
}

export type TRouteDef = {
  routeName: ERoute,
  routePattern: string,
  paramsParser?: ((params:{[key:string]:any}) => {[key:string]:string} | null) //todo
}

export type TRoute =
  | ({ routeName: ERoute.HOME } )
  | ({ routeName: ERoute.KIDS_CLASS} )
  | ({ routeName: ERoute.WHEEL_THROWING } )
  | ({ routeName: ERoute.FAMILY_SATURDAY } )
  | ({ routeName: ERoute.OPEN_STUDIO } )
  | ({ routeName: ERoute.FIRING_SERVICE } )
  | ({ routeName: ERoute.GIFT_CERTIFICATE } )
  | ({ routeName: ERoute.TEAM_EVENTS } )
  | ({ routeName: ERoute.BIRTHDAY_PARTIES } )
  | ({ routeName: ERoute.MEMBERSHIP } )
  | ({ routeName: ERoute.ABOUT } )
  | ({ routeName: ERoute.RENT_A_SPACE } )
  | ({ routeName: ERoute.CONTACT } )
  | ({ routeName: ERoute.IMPRESSUM } )
  | ({ routeName: ERoute.AGB } )
  | ({ routeName: ERoute.DATENSCHUTZ } )
  | ({ routeName: ERoute.NOT_FOUND } )

export const routeDefs:TRouteDef[] = [
  {routeName: ERoute.HOME, routePattern: '/'},
  {routeName: ERoute.KIDS_CLASS, routePattern: '/kids-class'},
  {routeName: ERoute.WHEEL_THROWING, routePattern: '/wheel-throwing'},
  {routeName: ERoute.FAMILY_SATURDAY, routePattern: '/family-saturday'},
  {routeName: ERoute.OPEN_STUDIO, routePattern: '/open-studio'},
  {routeName: ERoute.FIRING_SERVICE, routePattern: '/firing-service'},
  {routeName: ERoute.GIFT_CERTIFICATE, routePattern: '/gift-certificate'},
  {routeName: ERoute.TEAM_EVENTS, routePattern: '/team-events'},
  {routeName: ERoute.BIRTHDAY_PARTIES, routePattern: '/birthday-parties'},
  {routeName: ERoute.MEMBERSHIP, routePattern: '/membership'},
  {routeName: ERoute.ABOUT, routePattern: '/about-me'},
  {routeName: ERoute.RENT_A_SPACE, routePattern: '/rent-a-space'},
  {routeName: ERoute.CONTACT, routePattern: '/contact'},
  {routeName: ERoute.IMPRESSUM, routePattern: '/impressum'},
  {routeName: ERoute.AGB, routePattern: '/agb'},
  {routeName: ERoute.DATENSCHUTZ, routePattern: '/datenschutzerklaerung'},

  // {
  //   routeName: ERoute.ROUTE_TREE, routePattern: '/asd/:id', paramsParser: (params: {[key:string]:any}) => {
  //     if (params.id && typeof params.id === 'string') {
  //       return {id: params.id} as {id: string}
  //     } else {
  //       return null
  //     }
  //   }
  // }
]

